import React, { useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { deviceRenameApi } from "../../api";
import { deviceRename } from "../../redux";
import { Alert } from "..";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EditDeviceComp = (props) => {
  const { t } = useTranslation();
  const { device, toggleEdit } = props;
  const dispatch = useDispatch();
  let form = useRef();
  let caption = useRef();
  const token = Cookies.get("token");
  const initialValues = {
    caption: "",
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitForm = () => {
    const data = new FormData(form.current);
    data.append("serial", device.serial);
    deviceRenameApi(data, token)
      .then(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("دستگاه با موفقیت ویرایش شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
          toggleEdit();
          dispatch(
            deviceRename({
              serial: device.serial,
              caption: caption.current.value,
            })
          );
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const validationSchema = Yup.object({
    caption: Yup.string().required(t("نام دستگاه را وارد کنید.")),
  });

  return (
    <div style={{ minHeight: "60vh" }}>
      <div className="position-relative">
        {/* <p onClick={() => ProfileShowHideFunc('deviceMine')}
                        className="position-absolute cursor" style={{ right: '0', top: '0' }}>back</p> */}
        <div>
          <i className="circleTop icon-plug text-center m-auto"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("ویرایش نام دستگاه")}</p>
          </div>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form ref={form}>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                <p className="fn12 m-0 text-right">{t("نام دستگاه")}</p>
                <input
                  type="text"
                  placeholder={t("نام دستگاه")}
                  name="caption"
                  className="w-100 text-center fn12"
                  defaultValue={device.caption}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  ref={caption}
                />
              </div>
              <ErrorMessage name="caption">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-5">
              <button
                type="submit"
                className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              >
                <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                <small className="fn12 mt-1">{t("ویرایش")}</small>
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const EditDevice = withRouter(EditDeviceComp);

export { EditDevice };
